module.exports = __webpack_public_path__ + "static/media/md-beaker.f8edfa37.svg";